<template>
    <div class="new_soproni_small_area" v-if="products.length > 0">
        <div class="row">
            <div class="col-sm-12">
                <div class="section_title_box">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="section_title">
                                <div class="section_title_cont text-left">
                                    <h3>AJÁNLOTT TERMÉKEK</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-sm-12">
                <div class="soproni_small" style="padding-top:0px;padding-bottom:30px;">
                    <div class="row my-row">
                        <template v-if="products != null">
                            <div>
                                <product-list-view v-for="p in products" :product="p" :key="p.id"></product-list-view>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductListView from '@pages/list/ProductListView.vue'
import JS from './Promoted.js'

export default{
    mixins:[JS],
    components:{
        ProductListView
    },
}
</script>

<style>
.my-row {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display:         flex;
  flex-wrap: wrap;
}
.my-row div > [class*='col-'] {
  display: flex;
  flex-direction: column;
}
</style>

<style scoped>
.soproni_small{
    padding-top: 0px;
}
.new_soproni_small_area{
    margin-top:20px;
}
.col-centered{
    float: none;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Promoted.vue?fad6989c